<template>
  <HeadlessTransitionRoot
    appear
    :show="show"
    as="template"
  >
    <HeadlessDialog
      as="div"
      class="relative z-50"
      @close="close()"
    >
      <HeadlessTransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-25">
          <MouseFollower :hide-when-over-el="dialogPanelEl" />
        </div>
      </HeadlessTransitionChild>

      <div class="fixed bottom-0 left-0 top-0 w-screen overflow-y-auto">
        <div class="flex h-full items-center justify-center text-center lg:h-auto lg:min-h-full lg:p-4">
          <HeadlessTransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <HeadlessDialogPanel class="h-full w-full max-w-5xl shadow-xl transition-all lg:h-auto">
                <div ref="dialogPanelEl" class="flex h-full w-full transform flex-col items-stretch overflow-auto bg-whitegray lg:h-auto lg:flex-row lg:rounded-2xl">
                    <div v-if="deliveryData" class="flex flex-col w-full p-5 pt-16 lg:p-4">
                        <div class="text-xl mb-3">Адрес доставки успешно изменен</div>
                        <template v-if="deliveryData.delivery_dynamic_price">
                            <div class="text-lg">Максимальная стоимость доставки: <b>{{deliveryData.delivery_price}}&nbsp;&#8381;</b></div>
                            <div class="mb-3">Будет уменьшена в зависимости от стоимости блюд в корзине</div>
                        </template>
                        <template v-else>
                            <div class="text-lg">Стоимость доставки: <b>{{deliveryData.delivery_price}}&nbsp;&#8381;</b></div>
                        </template>

                        <div class="mb-5 text-lg" v-if="deliveryData.delivery_free_from > 0">Бесплатная доставке при заказе от: <b>{{deliveryData.delivery_free_from}}&nbsp;&#8381;</b></div>

                        <div>
                            <SimpleButton
                                class="flex-1 px-4 py-3 font-medium"
                                type="button"
                                @click="close"
                            >
                                Закрыть окно
                            </SimpleButton>
                        </div>
                        <button
                            class="absolute right-0 top-0 m-4 hidden lg:block"
                            type="button"
                            @click="close"
                        >
                            <IconClose class="h-6" />
                        </button>


                    </div>

                    <div v-else
                        class="flex h-full w-full transform flex-col items-stretch overflow-auto bg-whitegray lg:h-auto lg:flex-row lg:rounded-2xl"
                    >


                        <button
                            class="sticky top-0 z-50 flex items-center gap-2 bg-whitegray p-4 text-lg font-medium lg:hidden"
                            type="button"
                            @click="close()"
                        >
                            <IconArrowRight class="size-6 rotate-180 md:hidden" />
                            Выберите адрес
                        </button>

                        <div class="aspect-square h-[12rem] shrink-0 overflow-hidden lg:order-3 lg:h-[36rem] lg:rounded-xl"
                             v-if="isMapVisible || myReceptionWay !== 'delivery' || currentView == 'new' || currentView == 'edit'">
                            <MyYandexMap
                                :coordinates="coordinates"
                                show-center-marker
                                :markers="myReceptionWay == 'restaurant' ? markers : []"
                                @update-coords-drag="setMapCoords"
                            />
                        </div>

                        <Transition
                            name="fade"
                            mode="out-in"
                        >
                            <div
                                v-if="currentView === 'default'"
                                class="flex w-full flex-grow flex-col items-stretch p-4 lg:shrink lg:p-8 h-[12rem] lg:h-[36rem]"
                            >
                                <div class="rounded-xl bg-current bg-gray p-1.5 text-sm">
                                    <div class="relative">
                                        <div
                                            class="absolute bottom-0 left-0 top-0 w-1/2 rounded-lg bg-white shadow-main transition-transform"
                                            :class="{
                            'translate-x-0': myReceptionWay == 'delivery',
                            'translate-x-full': myReceptionWay == 'restaurant',
                          }"
                                        ></div>
                                        <button
                                            type="button"
                                            class="hover isolate h-10 w-1/2 rounded-lg"
                                            @click="myReceptionWay = 'delivery'"
                                        >
                                            Доставка
                                        </button>
                                        <button
                                            type="button"
                                            class="isolate h-10 w-1/2 rounded-lg"
                                            @click="myReceptionWay = 'restaurant'"
                                        >
                                            Самовывоз
                                        </button>
                                    </div>
                                </div>

                                <div class="h-0 grow">
                                    <Transition
                                        name="fade"
                                        mode="out-in"
                                    >
                                        <MyLocationDialogRestaurants
                                            v-if="myReceptionWay === 'restaurant'"
                                            class="flex-grow lg:shrink"
                                            @update-coords="coordinates = $event"
                                            @markers-updated="(m) => {markers = m}"
                                            @close="emit('close')"
                                            @location-changed="emit('locationChanged')"
                                        />
                                        <MyLocationDialogDelivery
                                            v-else-if="myReceptionWay === 'delivery'"
                                            class="flex-grow lg:shrink"
                                            @edit="editAddress($event)"
                                            @new="currentView = 'new'"
                                            @update-coords="coordinates = $event"
                                            @location-changed="emit('locationChanged')"
                                            @addresses-list-changed="addressesListChanged"
                                            @close="close"
                                        />
                                    </Transition>
                                </div>
                            </div>
                            <MyLocationDialogAddress
                                v-else
                                class="flex-grow lg:shrink"
                                :address="(currentView === 'edit') ? editingAddress : undefined"
                                :map-coords="mapCoords"
                                @update-coords="updateCoordinates($event)"
                                @go-back="currentView = 'default'"
                                @created-new-address="close()"
                                @go-back-and-pickup="currentView = 'default';myReceptionWay = 'restaurant'"
                            />
                        </Transition>
                    </div>
                </div>
            </HeadlessDialogPanel>
          </HeadlessTransitionChild>
        </div>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { LngLat } from '@yandex/ymaps3-types'
import type { Address } from '~/interfaces/main'
import type { MyCoords } from '~/interfaces/common'

const props = defineProps<{
  show?: boolean
}>()
const { show } = toRefs(props)
const emit = defineEmits(['close', 'locationChanged'])

const currentView = ref<'edit' | 'new' | 'default'>('default')
const editingAddress = ref<Address>()

/*const { data: markers } = useRestaurants((v) => {
    let m: any[] = []
    v.forEach((item) => {
        m.push({Lng: item.lng, Lat: item.lat, restaurantId: item.id})
    })
    return m
})*/

let markers = ref([]);
const editAddress = (address: Address) => {
  editingAddress.value = address
  currentView.value = 'edit'
}

let isMapVisible = ref(true)
const addressesListChanged = (addressesList) => {
    isMapVisible.value = addressesList?.length > 0
}

const coordinates = ref<LngLat>([37.617698, 55.755864])

const mapCoords = ref<LngLat>([37.617698, 55.755864])
const setMapCoords = (c: MyCoords) => {
  mapCoords.value = [c.Lng, c.Lat]
}
let externalChange = false;
const updateCoordinates = (newCoordinates: (any)) => {
    if(Array.isArray(newCoordinates[0])) {
        if(!newCoordinates[1]) {
            coordinates.value = newCoordinates[0];
        }

    } else {
        coordinates.value = newCoordinates;
    }
}

const deliveryData = ref()
const close = (response) => {
    if (response?.show_delivery_price) {
        deliveryData.value = response
        return
    }
  emit('close')
    setTimeout(() => {
        deliveryData.value = undefined
    }, 300)
  if (currentView.value !== 'default') {
    setTimeout(() => {
      currentView.value = 'default'
    }, 300)
  }
}

const { data: usersReceptionWay } = useCurrentReceptionWay()

const myReceptionWay = ref<'delivery' | 'restaurant'>('delivery')

watch(
  [usersReceptionWay],
  () => {
    if (usersReceptionWay.value) {
      myReceptionWay.value = usersReceptionWay.value.type
    }
  },
  {
    immediate: true,
  }
)
const dialogPanelEl = ref<HTMLElement>()
</script>
